// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectTradingSignalCancelMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_CANCEL_TRADING_SIGNAL_MESSAGE);
        this.TradingSignalId = null;
    }
}
